import { NavItem } from "@/components/sidebar/types";
import { RouteName } from "@/router/types";
import {
  SettingsCardInfo,
  SettingsCardSections
} from "@/components/settings/types";
import { i18n } from "@/plugins/i18n/vue-i18n-plugin";
import {
  LocaleSettingsCardsOther,
  LocaleSettingsCardsPersonal,
  LocaleSettingsCardsProfile,
  LocaleSidebarString
} from "@/plugins/i18n/types";
import { UserInfo, UserRole } from "@/services/apiService/api.types";
import { VoDType as VodTypeFilter } from "@/components/VoD/types";

export const baseurl = process.env.VUE_APP_API_BASE_URL;

//TODO: add items as usage of localstorage items expands
export enum LocalStorageItems {
  Token = "Token",
  CustomChannelList = "CustomChannelList",
  SortedCategories = "SortedCategories",
  Promotions = "Promotions",
  SortedBuffetCategories = "SortedBuffetCategories",
  ProviderData = "ProviderData",
  UserInfo = "UserInfo",
  AppMenuItems = "AppMenuItems",
  HomePageWidgets = "HomePageWidgets",
  MoviesByGenre = "MoviesByGenre",
  TvShowsByGenre = "TvShowsByGenre",
  FavoriteMovies = "FavoriteMovies",
  FavoriteTvShows = "FavoriteTvShows",
  DeviceId = "DeviceId"
}

export enum Categories {
  AllChannels = "All Channels",
  Movies = "Movies",
  Documentary = "Documentary",
  Sport = "Sport",
  Kids = "Kids",
  Informative = "Informative",
  Music = "Music",
  "Foreign informative" = "Foreign informative",
  Porno = "Porno",
  Favorites = "Favorites"
}

export enum AppMenuItemsPos {
  "Search",
  "Home",
  "Channels",
  "Buffet",
  "VoD",
  "Applications",
  "Settings"
}

export const NavItems: NavItem[] = [
  {
    icon: "HomeIcon",
    routeName: RouteName.Home,
    defaultElement: "#liveHeading",
    text: i18n.t(LocaleSidebarString.home) as string,
    name: AppMenuItemsPos.Home,
    position: 100
  },
  {
    icon: "ChannelsIcon",
    routeName: RouteName.Channels,
    defaultElement: "#firstChannel",
    text: i18n.t(LocaleSidebarString.channels) as string,
    name: AppMenuItemsPos.Channels,
    position: 100
  },
  {
    icon: "BuffetIcon",
    routeName: RouteName.Buffet,
    defaultElement: "",
    text: i18n.t(LocaleSidebarString.buffet) as string,
    name: AppMenuItemsPos.Buffet,
    position: 100
  },
  {
    icon: "VodIcon",
    routeName: RouteName.VoD,
    defaultElement: "#" + VodTypeFilter.Movies,
    text: i18n.t(LocaleSidebarString.vod) as string,
    name: AppMenuItemsPos.VoD,
    position: 100
  },
  {
    icon: "SettingsIcon",
    routeName: RouteName.Settings,
    defaultElement: "#" + SettingsCardSections.Profile + "0",
    text: i18n.t(LocaleSidebarString.settings) as string,
    name: AppMenuItemsPos.Settings,
    position: 100
  }
];

export enum BuffetCategories {
  Movies = "Movies",
  "TV Shows" = "TV Shows",
  Sport = "Sport",
  Info = "Info",
  Documentary = "Documentary",
  News = "News",
  "Culture and Art" = "Culture and Art",
  Music = "Music",
  Kids = "Kids",
  Reality = "Reality",
  Porno = "Porno",
  Home = "Home"
}

export const SettingsCardsPersonal: SettingsCardInfo[] = [
  {
    settingsCardTitle: {
      subHeading: i18n.t(LocaleSettingsCardsPersonal.logout) as string
    },
    icon: require("@/assets/svg/svg-home/00-home.svg"),
    opensRightSideMenu: true,
    rightSideMenuTitle: {
      heading: i18n.t(LocaleSettingsCardsPersonal.logout) as string,
      subHeading: ""
    }
  },
  {
    settingsCardTitle: {
      subHeading: i18n.t(LocaleSettingsCardsPersonal.restart) as string
    },
    icon: require("@/assets/svg/svg-home/07-settings.svg"),
    opensRightSideMenu: true,
    rightSideMenuTitle: {
      heading: i18n.t(LocaleSettingsCardsPersonal.restart) as string,
      subHeading: ""
    }
  },
  {
    settingsCardTitle: {
      heading: i18n.t(LocaleSettingsCardsPersonal.languageHeading) as string,
      subHeading: i18n.t(
        LocaleSettingsCardsPersonal.languageSubHeading
      ) as string
    },
    icon: require("@/assets/svg/svg-settings/00-language-icon.svg"),
    opensRightSideMenu: true,
    rightSideMenuTitle: {
      heading: i18n.t(LocaleSettingsCardsPersonal.languageHeading) as string,
      subHeading: i18n.t(
        LocaleSettingsCardsPersonal.languageSubHeading
      ) as string
    }
  },
  {
    settingsCardTitle: {
      heading: i18n.t(LocaleSettingsCardsPersonal.pinHeading) as string,
      subHeading: i18n.t(LocaleSettingsCardsPersonal.pinSubHeading) as string
    },
    icon: require("@/assets/svg/svg-settings/02-lock-icon.svg"),
    opensRightSideMenu: true,
    rightSideMenuTitle: {
      heading: i18n.t(LocaleSettingsCardsPersonal.pinHeading) as string,
      subHeading: i18n.t(LocaleSettingsCardsPersonal.pinSubHeading) as string
    }
  }
];

export const SettingsCardsOther: SettingsCardInfo[] = [
  {
    settingsCardTitle: {
      heading: i18n.t(LocaleSettingsCardsOther.sortAndLockHeading) as string,
      subHeading: i18n.t(LocaleSettingsCardsOther.supportSubHeading) as string
    },
    icon: require("@/assets/svg/svg-settings/03-channels-icon.svg"),
    attachedRoute: RouteName.ChannelSortAndLock,
    requiresPin: true
  },
  {
    settingsCardTitle: {
      heading: i18n.t(LocaleSettingsCardsOther.supportHeading) as string,
      subHeading: i18n.t(LocaleSettingsCardsOther.supportSubHeading) as string
    },
    icon: require("@/assets/svg/svg-settings/04-info-icon.svg"),
    opensRightSideMenu: true,
    rightSideMenuTitle: {
      heading: "Support",
      subHeading: "Provider Contract"
    }
  }
];

export const SettingsCardsProfile: SettingsCardInfo = {
  settingsCardTitle: {
    heading: i18n.t(LocaleSettingsCardsProfile.userHeading) as string
  },
  requiresPin: true,
  attachedRoute: RouteName.EditProfile
};

export const defaultUserInfo: UserInfo = {
  id: 0,
  username: "",
  email: "",
  role: UserRole.Parent,
  user_channel_package_id: 0,
  user_profile_package_id: 0,
  status: 0,
  deleted: 0,
  profile: {
    first_name: "",
    last_name: "",
    birth: null,
    mobile_number: undefined
  }
};

export const UNAUTHORIZED = 401;

export enum FavoriteStatus {
  Active = 10,
  Inactive = 5
}

export enum VoDType {
  Movie = 1,
  TvShow = 2
}

export enum PlayerControlsEnum {
  Rewind = "Rewind",
  FastForward = "FastForward",
  Start = "Start",
  End = "End"
}
